import {
	GET_SUBSCRIPTIONTYPES,
} from '../../Actions/Admin/ManageSubscriptionTypeActions';

const initialState = {
	subscriptions: [],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SUBSCRIPTIONTYPES:
			return {
				...state,
				loading: true,
				subscriptionTypes: action.payload
			};
		default:
			return state;
	}
};
